import { Link } from 'react-router'

interface BreadcrumbProps {
  crumbStyle?: string
  to: string
  label?: string
}

export const Breadcrumb = ({ crumbStyle, to, label }: BreadcrumbProps) => {
  return (
    <Link className={crumbStyle} to={to}>
      {label}
    </Link>
  )
}
